import React from 'react';
import { InputGroup, Input, Button } from 'reactstrap';


const SearchBox = ({
  changeValue,
  text,
  open,
  Desktop,
  toggleAdvanced,
}) => (
    <React.Fragment>
      <InputGroup>
        <div className="input-group-prepend">
          <span className="input-group-text">
            <i className="fa fa-search" />
          </span>
        </div>

        <Input
          type="text"
          placeholder="Search something"
          value={text}
          onChange={(e) => changeValue(e.target.value)}
        />
        {!open && (
          <Desktop>
            <div className="input-group-append">
              <Button type="button" color="primary" onClick={toggleAdvanced}>
                Advanced
            {' '}
                <i className="fa fa-caret-down" />
              </Button>
            </div>
          </Desktop>
        )}
      </InputGroup>
    </React.Fragment>
  );

export default SearchBox;
